module.exports = __webpack_public_path__ + "img/odrex-logo-ua.74678fbd.svg";